import _asyncToGenerator from "@babel/runtime/helpers/asyncToGenerator";
import _classCallCheck from "@babel/runtime/helpers/classCallCheck";
import _createClass from "@babel/runtime/helpers/createClass";
import _defineProperty from "@babel/runtime/helpers/defineProperty";
import _regeneratorRuntime from "@babel/runtime/regenerator";
import { updateChunksWithDiffObjects } from './commands';
import { getPluginState } from './plugin-factory';
import { getBlocksSentences } from './utils';
export var NUMBER_OF_BLOCKS_PER_REQUEST = 3;
export var NUMBER_OF_SENTENCES_PER_REQUEST = 7;
/**
 * Delay between requests and how do we increase this delay
 * 	is temporary till we figure something solid based on document size.
 * Till then we will go ahead with;
 * - start 1st request immediately
 * - send 2nd request after 5 seconds
 * - send 3rd request after 7 seconds, 4th one at 7 seconds
 * - for 5th one increase by another 2 seconds and send request after 9 seconds
 * - so on ..., till max delay is 15 seconds
 */
export var DELAY_BETWEEN_TWO_CHECKS = 4 * 1000;
export var NUMBER_OF_REQUESTS_FOR_INCREASE = 2;
export var DELAY_INCREASE = 2 * 1000;
export var MAX_DELAY = 14000;
export var defaultConfig = {
  enabled: false,
  blocksPerRequest: NUMBER_OF_BLOCKS_PER_REQUEST,
  sentencesPerRequest: NUMBER_OF_SENTENCES_PER_REQUEST,
  timings: {
    delayBetweenChecks: DELAY_BETWEEN_TWO_CHECKS,
    numberOfRequestsForIncrease: NUMBER_OF_REQUESTS_FOR_INCREASE,
    delayIncrease: DELAY_INCREASE,
    maxDelay: MAX_DELAY
  }
};
export var DocumentSGChecker = /*#__PURE__*/function () {
  function DocumentSGChecker() {
    _classCallCheck(this, DocumentSGChecker);
    _defineProperty(this, "config", defaultConfig);
    _defineProperty(this, "chunksPerRequest", NUMBER_OF_BLOCKS_PER_REQUEST);
    _defineProperty(this, "currentDelay", DELAY_BETWEEN_TWO_CHECKS);
    _defineProperty(this, "requestsSentSinceLastIncrease", 0);
  }
  _createClass(DocumentSGChecker, [{
    key: "getSGPluginState",
    value: function getSGPluginState() {
      if (this.view) {
        return getPluginState(this.view.state);
      }
    }

    /**
     * We need to get chunks before sending request each time because;
     * - now we have replacing blocks and sentences in pluginState;
     */
  }, {
    key: "getChunks",
    value: function getChunks() {
      var pluginState = this.getSGPluginState();
      if (pluginState) {
        var splitParagraphIntoSentences = pluginState.splitParagraphIntoSentences,
          proactiveAIBlocks = pluginState.proactiveAIBlocks;
        var blocks = proactiveAIBlocks || [];
        return splitParagraphIntoSentences ? getBlocksSentences(blocks) : blocks;
      }
      return [];
    }
  }, {
    key: "filterChunksNeedingSGCheck",
    value: function filterChunksNeedingSGCheck(chunks) {
      return chunks.filter(function (chunk) {
        return !!chunk.needSGCheckForDocChecker;
      });
    }
  }, {
    key: "getNextChunks",
    value: function getNextChunks() {
      var chunks = this.getChunks();
      chunks = this.filterChunksNeedingSGCheck(chunks);
      return chunks.slice(0, this.chunksPerRequest);
    }
  }, {
    key: "checkNextBlocks",
    value: function () {
      var _checkNextBlocks = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee() {
        var chunks;
        return _regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) switch (_context.prev = _context.next) {
            case 0:
              if (!(!this.view || !this.locale)) {
                _context.next = 2;
                break;
              }
              return _context.abrupt("return");
            case 2:
              chunks = this.getNextChunks();
              if (!chunks.length) {
                _context.next = 9;
                break;
              }
              _context.next = 6;
              return updateChunksWithDiffObjects(this.view, chunks, this.locale);
            case 6:
              this.setTimer();
              _context.next = 10;
              break;
            case 9:
              this.stop();
            case 10:
            case "end":
              return _context.stop();
          }
        }, _callee, this);
      }));
      function checkNextBlocks() {
        return _checkNextBlocks.apply(this, arguments);
      }
      return checkNextBlocks;
    }()
  }, {
    key: "setTimer",
    value: function setTimer() {
      if (this.currentDelay !== this.config.timings.maxDelay) {
        this.requestsSentSinceLastIncrease = this.requestsSentSinceLastIncrease + 1;
        if (this.requestsSentSinceLastIncrease < this.config.timings.numberOfRequestsForIncrease) {
          this.currentDelay = Math.min(this.config.timings.maxDelay, this.currentDelay + this.config.timings.delayIncrease);
          this.requestsSentSinceLastIncrease = 0;
        }
      }
      this.timerId = setTimeout(this.checkNextBlocks.bind(this), this.currentDelay);
    }
  }, {
    key: "setEditorViewAndLocale",
    value: function setEditorViewAndLocale(config, view, locale) {
      this.config = config;
      this.currentDelay = config.timings.delayBetweenChecks;
      this.chunksPerRequest = config.blocksPerRequest;
      this.view = view;
      this.locale = locale;
    }

    /**
     * When we start S+G check across whole document.
     *	- we will get chunks and filter them based on needSGCheckForDocChecker before each request.
     *	- when chunk is checked for S+G, needSGCheckForDocChecker is set to false for that chunk.
     *	- between this, if any block is updated checked for S+G, in that needSGCheckForDocChecker will
     *    	also be set to false.
     * 	- perform S+G check for chunksPerRequest every currentDelay (set to DELAY_BETWEEN_TWO_CHECKS)
     *    - increases delay every 2 requests by 2 seconds.
     */
  }, {
    key: "start",
    value: function start() {
      this.stop();
      var pluginState = this.getSGPluginState();
      var splitParagraphIntoSentences = pluginState === null || pluginState === void 0 ? void 0 : pluginState.splitParagraphIntoSentences;
      this.chunksPerRequest = splitParagraphIntoSentences ? this.config.sentencesPerRequest : this.config.blocksPerRequest;
      this.checkNextBlocks();
    }
  }, {
    key: "stop",
    value: function stop() {
      clearTimeout(this.timerId);
      this.timerId = undefined;
      this.currentDelay = this.config.timings.delayBetweenChecks;
      this.requestsSentSinceLastIncrease = 0;
    }
  }, {
    key: "reset",
    value: function reset() {
      this.stop();
      this.view = undefined;
      this.locale = undefined;
    }
  }]);
  return DocumentSGChecker;
}();